import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import RTPageLayout from '../common/RTPageLayout';
import Tile from '../common/Tile';
import RequireMenuAccess from '../common/RequireMenuAccess';
import { hasPermission } from '../../utils/permissions';
import '../common/rtCommon.css';
import '../common/Tile.css';
import './PaymentManagement.css';

const invoiceTiles = [
  {
    icon: '🧾',
    title: 'Create Invoice',
    permissionKey: 'payments.create_invoice',
    description: 'Manually create new invoices for specific paying guests',
    url: 'invoices/create',
  },
  {
    icon: '📅',
    title: 'Generate Monthly Rental Invoice',
    permissionKey: 'payments.generate_monthly',
    description:
      'Auto-generate rental invoices for all active paying guests for the current month',
    url: 'generate-monthly',
  },
  {
    icon: '⚡',
    title: 'Add EB Bill to Monthly Rental Invoices',
    permissionKey: 'payments.add_eb_bill',
    description:
      'Add EB charges to draft monthly rental invoices manually, by flat rate, or sheet upload',
    url: 'add-eb-bill',
  },
  {
    icon: '📄',
    title: 'View Draft Invoices',
    permissionKey: 'payments.view_draft_invoices',
    description: 'View and manage all invoices with filtering options',
    url: 'view-draft-invoices',
  },
  {
    icon: '📬',
    title: 'View Unpaid Invoices',
    permissionKey: 'payments.view_unpaid_invoices',
    description:
      'View all unpaid invoices (sent and overdue) with payment options',
    url: 'view-unpaid-invoices',
  },
];

const paymentTiles = [
  {
    icon: '💵',
    title: 'Add Payment',
    permissionKey: 'payments.add_payment',
    description: 'Record payments received from paying guests',
    url: 'add',
  },
  {
    icon: '💰',
    title: 'View Payments',
    permissionKey: 'payments.view_payments',
    description: 'View detailed payment records with filtering options',
    url: 'view-payments',
  },
  {
    icon: '🧾',
    title: 'Add Expense',
    permissionKey: 'payments.add_expense',
    description: 'Record hostel expenses by category and payment method',
    url: 'add-expense',
  },
  {
    icon: '📒',
    title: 'View Expenses',
    permissionKey: 'payments.view_expenses',
    description: 'View expense records with month filters',
    url: 'view-expenses',
  },
];

const renderTileGrid = (tiles, navigate) => {
  const visible = tiles.filter((tile) => hasPermission(tile.permissionKey));
  if (visible.length === 0) return null;

  return (
    <div className="rt-tiles-grid">
      {visible.map((tile) => (
        <Tile
          key={tile.permissionKey}
          icon={tile.icon}
          title={tile.title}
          description={tile.description}
          permissionKey={tile.permissionKey}
          onClick={() => tile.url && navigate(tile.url)}
          tabIndex={0}
          role="button"
          onKeyPress={(e) => {
            if (e.key === 'Enter' && tile.url) navigate(tile.url);
          }}
        />
      ))}
    </div>
  );
};

const PaymentManagement = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const invoicesSection = renderTileGrid(invoiceTiles, navigate);
  const paymentsSection = renderTileGrid(paymentTiles, navigate);

  return (
    <RequireMenuAccess>
      <RTPageLayout
        title="Payment Management"
        mainSection
        activePath={location.pathname}
      >
        {invoicesSection && (
          <div className="rt-section payment-mgmt-section">
            <h3 className="rt-section-title">Invoices</h3>
            {invoicesSection}
          </div>
        )}
        {paymentsSection && (
          <div className="rt-section payment-mgmt-section">
            <h3 className="rt-section-title">Payments & Expenses</h3>
            {paymentsSection}
          </div>
        )}
      </RTPageLayout>
    </RequireMenuAccess>
  );
};

export default PaymentManagement;
